import {
    Backdrop,
    Button,
    TableCell,
    tableCellClasses,
    TableRow,
} from "@mui/material";
import styled, { css, keyframes } from "styled-components";
import { color } from "../../../../shared/styles";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
    to {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
`;

export const ModalWrapper = styled.div<{ isOpen: boolean }>`
    padding: 24px;
    max-width: 80vw;
    width: 70vw;
    min-width: 500px;
    min-height: 50%;
    max-height: 80%;
    overflow: hidden;
    border-radius: 8px;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 32px;
    font-family: Noto Sans;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    animation: ${({ isOpen }) =>
        isOpen
            ? css`
                  ${fadeIn} 0.3s ease-out forwards
              `
            : css`
                  ${fadeOut} 0.3s ease-out forwards
              `};
`;

export const Expandable = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const TableWrapper = styled.div`
    overflow-y: auto;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const InfoText = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

export const TitleText = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
`;

export const SummaryTableRow = styled(TableRow)`
    background-color: ${color.secondary.LIGHT_GREY} !important;
    position: sticky;
    z-index: 10;
    bottom: 0;
`;

export const SummaryTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        color: "#0D0C0C",
        fontSize: "13px",
        fontWeight: "700",
        lineHeight: "28px",
        wordWrap: "break-word",
        padding: "2px 8px",
        fontFamily: "Noto Sans",
        whiteSpace: "normal",
    },
}));

export const ButtonRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 24px;
`;

export const StyledButton = styled(Button)`
    && {
        width: 100%;
        height: 51px;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
    }
`;

export const StyledBackdrop = styled(Backdrop)`
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
`;

export const TableWarningMessage = styled.div`
    padding: 22px 24px;
    border-radius: 8px;
    background-color: ${color.status.DANGER_LIGHT};
    font-size: 16px;
    display: flex;
    gap: 8px;
`;

export const TagName = styled.span<{ itemType: 'product' | 'material' }>`
    margin-left: 8px;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    background-color: ${props => props.itemType === 'product' ? color.primary.BLUE_B100 : color.status.WARNING};
    color: white;
    white-space: nowrap;
`;
